(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("UserExperior", [], factory);
	else if(typeof exports === 'object')
		exports["UserExperior"] = factory();
	else
		root["UserExperior"] = factory();
})(self, () => {
return 